import React from 'react'
import { connect } from 'react-redux'

class SendInvite extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      status: null,
      validEmail: false,
      error: false
    }
  }

  onChange(e) {
    this.setState({ email: e.target.value, validEmail: e.target.validity.valid, error: false })
  }

  sendEmail() {
    const domain = process.env.NODE_ENV === 'production' && process.env.__NOTIFICATION_ENV__ == 'production' ? 'app.basemap.com' : 'staging.basemap.com'

    const to = this.state.email;
    const subject = 'BaseMap Invitation';
    const body = `Hello,

          I've invited you to join me on BaseMap! To get started, please register and download the BaseMap app using the links below:

          Download the BaseMap App: https://${domain}/

      Once you've registered and installed the app, you’ll be ready to explore maps together!

      Thank you
    `;

    // Create a mailto URL
    const mailtoURL = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open the default email client with the predefined details
    window.location.href = mailtoURL;
  };

  submitEmail() {
    this.sendEmail()
  }

  render() {
    const { email, status, error } = this.state
    return (
      <div>
        <div className='friends-search-container'>
          <i className="material-icons"
            style={{ fontSize: '18px', verticalAlign: 'middle', textAlign: 'center' }}>
            email
          </i>
          <input type='email'
            className='friends-search'
            value={email}
            placeholder='Email'
            onChange={this.onChange.bind(this)}></input>
        </div>
        <button onClick={this.submitEmail.bind(this)}>Send Email</button>
        {
          error !== false ?
            (<div>
              <p style={{ width: '100%', color: 'red', textAlign: 'center' }}>{error}</p>
            </div>) : null
        }
        {
          error === false && status !== null ?
            (<div>
              <p style={{ width: '100%', color: 'green', textAlign: 'center' }}>{status}</p>
            </div>) : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(SendInvite)